import React, { useState } from 'react';
import { Check, Cpu, Cloud, Smartphone } from 'lucide-react';
import { SiteSection, SiteSectionHeader } from '../../../../components/site';
import { iotCloudTabs } from '../data';
import type { PlatformSubpageConfig } from '../types';

const diagramNodes = [
  { id: 'device', label: 'Devices', Icon: Cpu },
  { id: 'cloud', label: 'Cloud', Icon: Cloud },
  { id: 'app', label: 'Apps', Icon: Smartphone },
] as const;

export const IotCloudContent: React.FC<{ config: PlatformSubpageConfig }> = ({ config }) => {
  const [active, setActive] = useState<(typeof iotCloudTabs)[number]['id']>('events');
  const current = iotCloudTabs.find((t) => t.id === active) ?? iotCloudTabs[0];

  return (
    <SiteSection className="platform-iot-cloud-section platform-sub-interactive platform-sub-interactive--premium">
      <SiteSectionHeader
        eyebrow="INTERACTIVE"
        title={config.sections.title}
        subtitle={config.sections.subtitle}
        align="center"
      />
      <div className="platform-sub-interactive__shell">
        <div className="platform-sub-tabs platform-sub-tabs--premium" role="tablist" aria-label="Cloud architecture">
          {iotCloudTabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={active === tab.id}
              className={`platform-sub-tabs__btn${active === tab.id ? ' platform-sub-tabs__btn--active' : ''}`}
              onClick={() => setActive(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="platform-sub-panel platform-sub-cloud-panel platform-sub-cloud-panel--stacked">
          <div className="platform-sub-panel__copy">
            <h3 className="platform-sub-panel__title">{current.title}</h3>
            <p className="platform-sub-panel__desc">{current.description}</p>
            <ul className="platform-sub-panel__points">
              {current.points.map((p) => (
                <li key={p}>
                  <Check className="platform-sub-panel__point-icon" size={16} strokeWidth={2.5} aria-hidden />
                  {p}
                </li>
              ))}
            </ul>
          </div>
          <div className="platform-sub-cloud-diagram platform-sub-cloud-diagram--stack" aria-hidden>
            {diagramNodes.map((node, index) => (
              <React.Fragment key={node.id}>
                <div className="platform-sub-cloud-diagram__node">
                  <span className="platform-sub-cloud-diagram__icon-wrap">
                    <node.Icon className="platform-sub-cloud-diagram__icon" size={26} strokeWidth={1.6} />
                  </span>
                  <span className="platform-sub-cloud-diagram__label">{node.label}</span>
                </div>
                {index < diagramNodes.length - 1 ? (
                  <span className="platform-sub-cloud-diagram__connector" aria-hidden />
                ) : null}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </SiteSection>
  );
};
